import React from 'react';
import { Readiness } from '../../../types';
import { getReadinessDisplay, getReadinessDelta } from './reviewDisplay';
import css from './ReadinessBanner.module.scss';

interface ReadinessBannerProps {
  readiness: Readiness;
  previousReadiness: Readiness | null;
}

const ReadinessBanner: React.FC<ReadinessBannerProps> = ({
  readiness,
  previousReadiness,
}) => {
  const display = getReadinessDisplay(readiness);
  const delta = getReadinessDelta(previousReadiness, readiness);
  const prevShort = previousReadiness
    ? getReadinessDisplay(previousReadiness).short
    : null;

  return (
    <div className={`${css.banner} ${css[display.tone]}`} role="status">
      <div className={css.headline}>
        <span className={css.dot} aria-hidden="true" />
        <span className={css.label}>{display.label}</span>
      </div>

      {delta === 'improved' && prevShort && (
        <div className={css.deltaUp}>
          🎉 {prevShort} → {display.short}
        </div>
      )}
      {delta === 'unchanged' && (
        <div className={css.deltaNeutral}>Still: {display.short}</div>
      )}
      {delta === 'regressed' && prevShort && (
        <div className={css.deltaNeutral}>
          Changed since your last upload: {prevShort} → {display.short}
        </div>
      )}
    </div>
  );
};

export default ReadinessBanner;
